// extracted by mini-css-extract-plugin
module.exports = {"eventInfo":"_ibocI","mainEvent":"_2EShQY","link":"ePoe1W","image":"_1UcIYs","body":"_3W33Dx","eventGrid":"_2QMhsD","item":"_3SkzV9","moreDates":"_3tAUiC"};